/**
 * Create Quiz page
 */

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './create.css';

export default function CreateQuiz() {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [isPublic, setIsPublic] = useState(true);
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            const response = await fetch('/api/quizzes', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ title, description, isPublic }),
            });

            if (response.ok) {
                const data = await response.json();
                navigate(`/quiz/${data.quizId}/edit`);
            }
        } catch (error) {
            console.error('Failed to create quiz:', error);
        }
    };

    return (
        <main className="createQuizMain">
            <div className="createQuizHeader">
                <Link to="/" className="backLink">
                    ← Back to Quizzes
                </Link>
                <h2>Create a Quiz</h2>
            </div>
            <form className="createQuizForm" onSubmit={handleSubmit}>
                <label htmlFor="quiz-name">Name:</label>
                <input
                    id="quiz-name"
                    name="title"
                    type="text"
                    placeholder="My new quiz name"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                />
                <label htmlFor="quiz-description">Description:</label>
                <input
                    id="quiz-description"
                    name="description"
                    type="text"
                    placeholder="Any description you want to add"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                />

                <div className="checkboxGroup">
                    <input
                        id="quiz-public"
                        name="isPublic"
                        type="checkbox"
                        checked={isPublic}
                        onChange={(e) => setIsPublic(e.target.checked)}
                    />
                    <label htmlFor="quiz-public">Make this quiz available in the public/global registry</label>
                </div>

                <p>Simply name your quiz and then you can start to add in questions afterwards!</p>
                <button className="createQuizButton" type="submit" disabled={title === ''}>
                    Create
                </button>
            </form>
        </main>
    );
}
